import CareersComp from '../components/careersComp';

const Careers = () => {
    return <CareersComp />;
};

export default Careers;
